import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell, { StatusCellProps } from '@cas/components/data-display/status-cell/StatusCell';
import { CustomCellRendererProps } from 'ag-grid-react';
import { TFunction } from 'i18next';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const getSafetyAlertStatusText = (value: boolean, t: TFunction): string => {
  return value ? t('SafetyAlertStatus.Acknowledged') : t('SafetyAlertStatus.Active');
};

interface SafetyAlertAcknowledgedCellRendererProps<TData extends object> {
  value: CustomCellRendererProps<TData, boolean>['value'];
  size?: StatusCellProps['size'];
}

export default function SafetyAlertAcknowledgedCellRenderer<TData extends object>({
  value,
  size,
}: SafetyAlertAcknowledgedCellRendererProps<TData>): ReactElement | string {
  const { t } = useTranslation();

  const isAcknowledged = Boolean(value);
  const label = getSafetyAlertStatusText(isAcknowledged, t);
  const status = isAcknowledged ? BadgeStatus.Healthy : BadgeStatus.Danger;

  return <StatusCell label={label} status={status} size={size} />;
}
